/* Standalone email signup. Only public Klaviyo credentials belong in the theme. */
(() => {
  function bind(root) {
    const form = root.querySelector('[data-newsletter-form]');
    if (!form || form.dataset.bound) return;
    const email = form.querySelector('input[type="email"]');
    const consent = form.querySelector('input[type="checkbox"]');
    const button = form.querySelector('button[type="submit"]');
    const label = form.querySelector('[data-newsletter-button]');
    const error = form.querySelector('[data-newsletter-error]');
    const success = root.querySelector('[data-newsletter-success]');
    if (!email || !consent || !button || !label || !error || !success) return;
    // Keep an unconfigured or scriptless form from sending email addresses in a URL.
    form.addEventListener('submit', (event) => event.preventDefault());
    if (!form.dataset.siteId || !form.dataset.listId) return;
    form.dataset.bound = 'true';
    button.disabled = false;
    let pending = false;
    const defaultLabel = label.textContent;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (pending || !form.reportValidity() || !consent.checked) return;
      pending = true;
      button.disabled = true;
      email.readOnly = true;
      consent.disabled = true;
      error.hidden = true;
      label.textContent = form.dataset.pending;
      form.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.dataset.siteId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          signal: controller.signal,
          body: JSON.stringify({ data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.source || 'Velodrom newsletter page — explicit email opt-in',
              profile: { data: { type: 'profile', attributes: {
                email: email.value.trim(),
                locale: form.dataset.locale,
                properties: { 'Newsletter Language': form.dataset.locale },
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
          } })
        });
        if (response.status !== 202) {
          error.textContent = response.status === 429 ? form.dataset.rateLimit : form.dataset.error;
          error.hidden = false;
          return;
        }
        // Acceptance may start double opt-in; do not promise an active subscription.
        form.hidden = true;
        success.hidden = false;
        success.focus();
      } catch (_) {
        error.textContent = form.dataset.error;
        error.hidden = false;
      } finally {
        clearTimeout(timeout);
        pending = false;
        button.disabled = false;
        email.readOnly = false;
        consent.disabled = false;
        label.textContent = defaultLabel;
        form.removeAttribute('aria-busy');
      }
    });
  }
  function init() { document.querySelectorAll('[data-newsletter-page]').forEach(bind); }
  init();
  document.addEventListener('shopify:section:load', init);
})();
